import axios from 'axios';
import api from '../../config.json'
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import swal from 'sweetalert';
import validation from '../../utill/validation';
import joi from 'joi'
import Loading from '../../utill/LoadingComponent';
import { Select } from 'antd';

const AlertForm = ({ history, Heading }) => {
    const [formData, setFormData] = useState({});
    const [content, setContent] = useState("");
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const [types, setAllTypes] = useState([]);
    const handleOnChange = (name, value) => {
        const obj = { ...formData };
        obj[name] = value;
        const error = validation.validateProperty({ name: name, value: value }, schema)
        setErrors(error || {})
        setFormData(obj);
    }

    const location = useLocation();
    useEffect(() => {
        Heading('Alert Master Form')
    }, [])

    useEffect(() => {
        getAllTypes()
        if (location.state && location.state.action == 'update') {
            setFormData(location.state.data)
        }
    }, [location])

    const schema = {
        Name: joi.required().label('Subject'),
        Email: joi.string().label('Email'),
        Enable: joi.boolean(),
        _id: joi.string()
    }

    const getAllTypes = () => {
        setLoader(true)
        axios.get(api.api + 'userEmail')
            .then((result) => {
                setAllTypes(result.data.map(x => { return { label: x.InstrumentType, value: x.InstrumentType, _id: x._id } }))
                setLoader(false)
            })
            .catch((err) => {
                swal(`${err}`);
                setLoader(false)
            })
    }



    const handleSave = () => {
        delete formData.__v
        delete formData.createdAt
        delete formData.updatedAt
        const error = validation.validate(formData, schema)
        if (error) {
            setErrors(error)
            return
        }
        setErrors(error || {})
        setLoader(true)
        if (location.state && location.state.action == "update") {
            axios.patch(api.api + 'userEmail/' + formData._id, formData)
                .then((result) => {
                    swal('Update Successfully');
                    history.push('/setting/alert/list');
                    setLoader(false)
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        swal(`${err.response.data.message}`, { dangerMode: true });
                    } else {
                        swal(`${err}`);
                    }
                    setLoader(false)
                })
        } else {
            axios.post(api.api + 'userEmail', formData)
                .then((result) => {
                    swal('Save Successfully');
                    history.push('/setting/alert/list');
                    setLoader(false)
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        swal(`${err.response.data.message}`, { dangerMode: true });
                    } else {
                        swal(`${err}`);
                    }
                    setLoader(false)
                })
        }

    }
    return (

        <React.Fragment>
            {/* <div className='text-center'>
                <p>Instrument Master Form</p>
            </div> */}
            {loader ? <Loading /> : <></>}
            <div className="row mt-2">

                <div className="col-sm-4 ">
                    <div className="form-group text-center">
                        <label htmlFor="componentid">Subject</label>
                        <input
                            value={formData.Name || ""}
                            className="form-control form-control-sm"
                            required
                            type="text"
                            onChange={(e) => handleOnChange('Name', e.currentTarget.value)}
                            name="Name"
                            placeholder="Enter  Subject..."
                        />
                    </div>
                    {errors.Name && <div className="alert small alert-danger">{errors['Name']}</div>}
                </div>
                <div className="col-sm-3">
                    <div className="form-group text-center">
                        <label htmlFor="componentid">Email</label>
                        <input
                            value={formData.Email || ""}
                            className="form-control form-control-sm"
                            required
                            type="text"
                            onChange={(e) => handleOnChange('Email', e.currentTarget.value)}
                            name="Email"
                            placeholder="Enter email..."
                        />
                    </div>
                    {errors.Email && <div className="alert small alert-danger">{errors['Email']}</div>}
                </div>
                <div className="col-sm-2">
                    <div className="form-group text-center">
                        <label htmlFor="componentid">Alert Enable</label><br/>
                        <input
                        className='mt-2'
                            value={formData.Enable || ""}
                            required
                            checked={formData.Enable || false}
                            type="checkbox"
                            onChange={(e) => handleOnChange('Enable', e.currentTarget.checked)}
                            name="Enable"
                        />
                    </div>
                    {errors.Enable && <div className="alert small alert-danger">{errors['Enable']}</div>}
                </div>
            </div>
            <div className='row text-center mt-2'>
                <div className='col-sm-12'>
                    <button onClick={handleSave} className="btn-sm btn-primary">Submit</button>
                    <button onClick={() => history.push('/setting/alert/list')} className="btn-sm btn-primary ml-4">Cancel</button>
                </div>
            </div>
        </React.Fragment>
    );
}

export default AlertForm;